import { TagVariant } from '@creditornot/cb-tag';

import {
  SettlementReason,
  SettlementStatus,
  SettlementType,
} from '../../apis/restaurant-api/merchant-admin/settlements/types';

export const NUM_SETTLEMENTS_PER_PAGE = 40;
export const ROW_HEIGHT = 57;

export const SETTLEMENT_TYPES: { [key in SettlementType]: string } = {
  deduction: 'settlements.settlement-types.deduction',
  addition: 'settlements.settlement-types.addition',
  fee: 'settlements.settlement-types.fee',
};

export const SETTLEMENT_REASONS: { [key in SettlementReason]: string } = {
  missing_item: 'settlements.settlement-reasons.missing-item',
  wrong_item: 'settlements.settlement-reasons.wrong-item',
  quality_issue: 'settlements.settlement-reasons.quality-issue',
  other_deduction: 'settlements.settlement-reasons.other-deduction',
  courier_late: 'settlements.settlement-reasons.courier-late',
  courier_mix_up: 'settlements.settlement-reasons.courier-mix-up',
  courier_delivery: 'settlements.settlement-reasons.courier-delivery',
  other_addition: 'settlements.settlement-reasons.other-addition',
  other_sale_correction: 'settlements.settlement-reasons.other-sale-correction',
  venue_lateness: 'settlements.settlement-reasons.venue-lateness',
};

export const SETTLEMENT_STATUSES: { [key in SettlementStatus]: string } = {
  settled: 'settlements.settlement-statuses.settled',
  not_settled: 'settlements.settlement-statuses.not-settled',
};

export const SETTLEMENT_REASON_TAG_VARIANT: TagVariant = 'lightBlack';
export const SETTLEMENT_STATUS_TAG_VARIANT: { [key in SettlementStatus]: TagVariant } = {
  settled: 'lightBlue',
  not_settled: 'outlineBlue',
};

export const DELIVERY_STATUSES: { [key: string]: string } = {
  delivered: 'purchases.delivery-statuses.delivered',
  production: 'purchases.delivery-statuses.production',
  ready: 'purchases.delivery-statuses.ready',
  received: 'purchases.delivery-statuses.received',
  rejected: 'purchases.delivery-statuses.rejected',
  refunded: 'purchases.delivery-statuses.refunded',
};

export const DELIVERY_TYPES: { [key: string]: string } = {
  eatin: 'delivery-types.eatin',
  homedelivery: 'delivery-types.homedelivery',
  takeaway: 'delivery-types.takeaway',
};
